import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faDatabase, faHardHat, faMapMarkerAlt, faUserSlash, faIdBadge, faUserTie
} from '@fortawesome/free-solid-svg-icons';
import './ThinkContract.css';
// import thinkhealthimage from '../../assets/pageimages/thinkhealthimage.webp';

function ThinkContractPrincipalEmployer() {

  const LinkButton = ({ to, icon, label }) => (
    <div className="flex justify-center">
      <Link
        to={to}
        className="flex items-center flex-wrap justify-center p-3 w-full bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-all duration-300"
      >
        <FontAwesomeIcon icon={icon} className="text-xl sm:text-xl mr-3" />
        <span>{label}</span>
      </Link>
    </div>
  );

  const LinkNoButton = ({ to, icon, label }) => (
    <div className="flex justify-center">
      <Link
        to={to}
        className="flex items-center flex-wrap justify-center p-3 w-full bg-gray-200 text-gray-800 font-semibold rounded-lg hover:bg-gray-300 transition-all duration-300"
      >
        <FontAwesomeIcon icon={icon} className="text-xl sm:text-xl mr-3" />
        <span>{label}</span>
      </Link>
    </div>
  );

  return (
    <MainLayout>
      <div className="mt-12 text-sm min-h-screen bg-gradient-to-r from-green-600 via-green-700 to-green-800 flex flex-col items-center py-8">
        <p className="text-xl font-bold text-white text-center mb-4">Principal Employer Dashboard</p>
        {/* <img
            src={thinkhealthimage}
            alt="ThinkHealth"
            className="w-1/3 h-auto max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl rounded-lg shadow-lg flex-wrap"
          /> */}

        <div className="flex-grow">
          <div className="grid grid-cols md:grid-cols lg:grid-cols-5 gap-4 p-4 bg-gray-600 rounded-lg shadow-lg transition-transform transform hover:scale-105 mx-4 mt-6">
            <LinkButton to="/think-contract-principalemployer-profile" icon={faDatabase} label="Master Record" />
            <LinkNoButton to="" icon={faUserTie} label="Manager" />
            <LinkNoButton to="" icon={faHardHat} label="Contractors" />
            <LinkNoButton to="" icon={faMapMarkerAlt} label="Work Site" />
            <LinkNoButton to="" icon={faUserSlash} label="Termination" />
            <LinkNoButton to="" icon={faIdBadge} label="License" />

          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default ThinkContractPrincipalEmployer;
